// =============================================================================
// FORM VALIDATION — Bootstrap 5 native HTML5 validation (no jQuery)
// =============================================================================

export function initFormValidation() {
  document.querySelectorAll('form.needs-validation').forEach(form => {
    form.addEventListener('submit', (e) => {
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
      }
      form.classList.add('was-validated');
    });
  });
}
